import { idKeys, WithId } from './types.ts';

type GetValidId = <T extends WithId>(obj: T) => string;

export const getValidId: GetValidId = <T extends WithId>(obj: T): string => {
  const key = idKeys.find(k => obj[k])!;
  return obj[key] as string;
};
